import * as React from 'react';
import { SVGProps } from 'react';

const SvgDiningOptions = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.778 9.9H9.334V5H7.89v4.9H6.446V5H5.002v4.9c0 1.484 1.199 2.688 2.708 2.779V19h1.806v-6.321c1.509-.091 2.708-1.295 2.708-2.779V5H10.78v4.9zm4.611-2.1v5.6h1.806V19h1.806V5c-1.993 0-3.611 1.568-3.611 2.8z" />
  </svg>
);

export default SvgDiningOptions;
